import { fromUnixTime, isBefore } from "date-fns/esm";

import { getNowTimeMs } from "utils/time";

export const isApiKeyExpired = (expiresAt: number | null | undefined): boolean =>
  !!expiresAt && isBefore(fromUnixTime(expiresAt), getNowTimeMs());
